import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { ActionLink } from '@/content/home';
import { ButtonAnchor, ButtonLink } from './Button';
import { Icon } from './Icon';

/** 渲染内容层里的 ActionLink：站内给 react-router，站外给 `<a>`，外链带一个小箭头。 */
export function ActionButton({ action, className }: { action: ActionLink; className?: string }) {
  const children = (
    <>
      {action.label}
      {action.external ? <Icon name="external" size={15} /> : null}
    </>
  );

  if (action.external) {
    return (
      <ButtonAnchor href={action.to} variant={action.variant} external className={className}>
        {children}
      </ButtonAnchor>
    );
  }

  return (
    <ButtonLink to={action.to} variant={action.variant} className={className}>
      {children}
    </ButtonLink>
  );
}

export function ActionRow({ actions, className }: { actions: readonly ActionLink[]; className?: string }) {
  return (
    <div className={['flex flex-wrap items-center gap-x-3 gap-y-2.5', className].filter(Boolean).join(' ')}>
      {actions.map((action) => (
        <ActionButton key={`${action.label}-${action.to}`} action={action} />
      ))}
    </div>
  );
}

/** 文字链接，用于"了解更多 →"这类轻量入口。 */
export function TextLink({ to, children, className }: { to: string; children: ReactNode; className?: string }) {
  const isExternal = /^https?:/i.test(to);
  const classes = [
    'inline-flex items-center gap-1.5 text-sm font-medium text-brand transition-colors hover:text-brand-hover',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (isExternal) {
    return (
      <a href={to} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
        <Icon name="external" size={14} />
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {children}
      <Icon name="arrowRight" size={14} />
    </Link>
  );
}
